import React, { useEffect, useState, useMemo, useRef } from "react";
import { ProfileService } from "../../../../services/ProfileService";
import { showSalary } from "../../../../utilities/showsalary";
import orgImage from "../../../../../src/assets/img/images/office.jpeg";
import { useHistory } from "react-router-dom";
import { Stringutility } from "../../../../utilities/stringutility";

const JobSuggestions = () => {
  const history = useHistory();
  const [jobSuggestions, setJobSuggestions] = useState([]);
  let count = 0;
  useEffect(() => {
    getjobsuggestions();
  }, [count]);

  const navigateTo = (id) => {
    const jobIdReq = { jobId: id };
    history.push("/Jobsuggestiondetails", jobIdReq);
  };

  const getjobsuggestions = () => {
    ProfileService.getSuggestions().then((response) => {
      try {
        var jobsuggestions = response.data;
        if (jobsuggestions !== null) {
          {
            setJobSuggestions(jobsuggestions.jobs);
          }
        }
      } catch (err) {
        console.error("getjobsuggestions" + JSON.stringify(err));
      }
    });
  };

  const getJobBenefits = (jobBenefits) => {
    const bList = [];
    const maxBenefitsToShow = 6;
    let count = 0;
    const benefitsArray = [
      { key: "cobra", label: "Cobra" },
      { key: "Disability", label: "Disability" },
      { key: "medicalLeave", label: "MedicalLeave" },
      { key: "minimumWage", label: "MinimumWage" },
      { key: "overtime", label: "Overtime" },
      { key: "unEmploymentBenefit", label: "UnEmploymentBenefit" },
      { key: "WorkerCompensation", label: "WorkerCompensation" },
      { key: "bonusPay", label: "BonusPay" },
      { key: "compensation401k", label: "401k" },
      { key: "stockOption", label: "StockOption" },
      { key: "health", label: "Health" },
      { key: "dental", label: "Dental" },
      { key: "vision", label: "Vision" },
      { key: "lifeInsurance", label: "Life Insurance" },
      { key: "paidHoliday", label: "Paid Holidays" },
      { key: "paidSickTime", label: "Paid SickTime" },
      { key: "paidVacation", label: "Paid Vacation" },
      { key: "flexibleHour", label: "Flexible Hour" },
      { key: "parentalLeave", label: "Parental Leave" },
      { key: "tuition", label: "Tuition" },
      {
        key: "profDeveAssistance",
        label: "Professional Development Assistance ",
      },
      { key: "empDiscount", label: "Employee Discounts" },
    ];

    for (const benefit of benefitsArray) {
      if (jobBenefits[benefit.key] && count < maxBenefitsToShow) {
        bList.push(
          <span
            key={benefit.key}
            className="inline-block mb-1 bg-Gray-600 font-semibold text-white text-xs rounded-[4px] mr-1 px-2 pb-[2px]"
          >
            {benefit.label}
          </span>
        );
        count++;
      }
    }
    return <div>{bList}</div>;
  };

  const getTotalSelectedBenefits = (jobBenefits) => {
    var add = [];
    if (jobBenefits.cobra) {
      add.push("Cobra");
    }
    if (jobBenefits.Disability) {
      add.push("Disability");
    }
    if (jobBenefits.medicalLeave) {
      add.push("MedicalLeave");
    }
    if (jobBenefits.minimumWage) {
      add.push("MinimumWage");
    }
    if (jobBenefits.overtime) {
      add.push("overtime");
    }
    if (jobBenefits.unEmploymentBenefit) {
      add.push("UnEmploymentBenefit");
    }
    if (jobBenefits.WorkerCompensation) {
      add.push("WorkerCompensation");
    }
    if (jobBenefits.bonusPay) {
      add.push("BonusPay");
    }
    if (jobBenefits.compensation401k) {
      add.push("401k");
    }
    if (jobBenefits.stockOption) {
      add.push("StockOption");
    }
    if (jobBenefits.health) {
      add.push("Health");
    }
    if (jobBenefits.dental) {
      add.push("Dental");
    }
    if (jobBenefits.vision) {
      add.push("Vision");
    }
    if (jobBenefits.lifeInsurance) {
      add.push("Life Insurance");
    }
    if (jobBenefits.paidHoliday) {
      add.push("Paid Holidays");
    }
    if (jobBenefits.paidSickTime) {
      add.push("Paid Holidays");
    }
    if (jobBenefits.paidVacation) {
      add.push("Paid Vacation");
    }
    if (jobBenefits.flexibleHour) {
      add.push("Flexible Hour");
    }
    if (jobBenefits.parentalLeave) {
      add.push("Parental Leave");
    }
    if (jobBenefits.tuition) {
      add.push("Tuition");
    }
    if (jobBenefits.profDeveAssistance) {
      add.push("Professional Development Assistance");
    }
    if (jobBenefits.empDiscount) {
      add.push("Employee Discounts");
    }
    return add.join(", ");
  };

  const showSalaryType = (salaryType) => {
    if (salaryType !== null) {
      if (salaryType != null) {
        if (salaryType.key === "HOURLY") {
          return "hour";
        } else if (salaryType.key === "ANNUAL") {
          return "year";
        } else if (salaryType.key === "MONTHLY") {
          return "month";
        }
        return salaryType.value;
      }
    }
  };

  const checkJobSalary = (jobResponse) => {
    if (jobResponse !== null) {
      let salaryMin = jobResponse.salaryMin;
      let salaryMax = jobResponse.salaryMax;
      let salaryType = jobResponse.salaryType;

      if (salaryMin == 0 && salaryMax == 0) {
        return <></>;
      } else if (salaryMin !== 0 && salaryMax == 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == 0 && salaryMax !== 0) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" + showSalary(salaryMax, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else if (salaryMin == salaryMax) {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)}/
            {showSalaryType(salaryType)} DOE{" "}
          </div>
        );
      } else {
        return (
          <div className="pay bg-primary-blue rounded text-[16px] text-white font-bold text-center my-2 inline-block pt-[2px] px-[10px] pb-1">
            {" "}
            {"$" +
              showSalary(salaryMin, salaryMin, salaryMax) +
              "-" +
              "$" +
              showSalary(salaryMax, salaryMin, salaryMax)}
            /{showSalaryType(salaryType)}{" "}
          </div>
        );
      }
    }
  };

  const displayLocation = (location) => {
    var arr = [];
    let city = Stringutility.getValue(location.city);
    if (city != "") {
      arr.push(city);
    }
    let state = Stringutility.getValue(location.state);
    if (state != "") {
      arr.push(state);
    }
    let zipcode = Stringutility.getValue(location.zipcode);
    if (zipcode != "") {
      arr.push(zipcode);
    }
    return arr.join(", ");
  };

  return (
    <>
    {jobSuggestions.length == 0 ?(<></>):(<><h1 className="text-2xl font-bold mb-3 text-Gray-900">Job Suggestions</h1></>)}
    <div className="jobsuggestions_wrapper touch-pan-y items-center w-full">
        <div className="jobsuggestions flex flex-col gap-7 pl-2 pb-4 max-md:w-auto 
                                    min-lg:pr-4
                                    hover:scrollbar-thin scrollbar-none scrollbar-thumb-rounded-md scrollbar-thumb-Blue-600 scrollbar-track-Gray-200
                        ">
          {jobSuggestions.length > 0 ? (
            jobSuggestions.map((suggestions, index) => {
              return (
                <div key={index}>
                  {/* <div className="jobsuggestions flex flex-row gap-3 pl-2 pb-4 max-md:w-auto max-md:py-5 max-md:px-5"> */}
                  
                    <div
                      href="/"
                      onClick={(e) => navigateTo(suggestions.id)}
                      // className="jobsuggestion grid bg-white rounded-2xl t-shadow-lg px-6 py-7 gap-2 grid-cols-4 w-min items-start min-w-[350px] h-fit temanics-link-pointer t-sug-card-height"
                    className="jobsuggestion grid bg-white rounded-2xl t-shadow-lg px-6 py-7 gap-2 grid-cols-4 w-min items-start min-w-[100%] h-fit  t-sug-card-height"
                    >
                      <div className="jobsuggestion_company w-16 h-16 flex items-center border-primary-gray2 border rounded-lg t-suggestion-img-height col-span-1">
                        {suggestions.displayAccountInfo ? (
                          suggestions.account != null ? (
                            !Stringutility.isNullOrEmpty(
                              suggestions.account.bgImage
                            ) ? (
                              <img
                                className="w-full h-auto"
                                src={suggestions.account.bgImage}
                                alt="Company"
                              />
                            ) : (
                              <img
                                className="w-full h-[100%] "
                                src={orgImage}
                                alt="Company"
                              />
                            )
                          ) : (
                            <img
                              className="w-full h-[100%] "
                              src={orgImage}
                              alt="Company"
                            />
                          )
                        ) : (
                          <img
                            className="w-full h-[100%] "
                            src={orgImage}
                            alt="Company"
                          />
                        )}
                      </div>
                      <div className="jobsuggestion_info col-span-3">
                        <div className="text-lg font-bold text-primary-blue pb-1">
                          {" "}
                          {suggestions.publicTitle ? (
                            <>
                              <div title={suggestions.publicTitle}>
                                <div
                                  className=""
                                  style={{ textOverflow: "clip" }}
                                >
                                  {suggestions.publicTitle.length > 20
                                    ? suggestions.publicTitle.substring(0, 20) +
                                      "..."
                                    : suggestions.publicTitle}
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <div title={suggestions.jobTitle}>
                                <div
                                  className=""
                                  style={{ textOverflow: "clip" }}
                                >
                                  {suggestions.jobTitle.length > 20
                                    ? suggestions.jobTitle.substring(0, 20) +
                                      "..."
                                    : suggestions.jobTitle}
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                        <div className="text-primary-dark font-semibold text-sm">
                          {suggestions.displayAccountInfo == true ? (
                            <>
                              {suggestions.account != null &&
                              !Stringutility.isNullOrEmpty(
                                suggestions.account.name
                              ) ? (
                                <div title={suggestions.account.name}>
                                  <div
                                    className=""
                                    style={{ textOverflow: "clip" }}
                                  >
                                    {suggestions.account.name.length > 20
                                      ? suggestions.account.name.substring(
                                          0,
                                          25
                                        ) + "..."
                                      : suggestions.account.name}
                                  </div>
                                </div>
                              ) : (
                                <>&nbsp;&nbsp;</>
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                        {!Stringutility.isNullOrEmpty(suggestions.location) &&
                        !Stringutility.isNullOrEmpty(suggestions.address) ? (
                          <>
                            {suggestions.location != null &&
                              suggestions.address != null && (
                                <div
                                  className="text-Gray-600 t-address-container"
                                  title={displayLocation(suggestions.address)}
                                >
                                  {displayLocation(suggestions.address)}{" "}
                                </div>
                              )}
                          </>
                        ) : (
                          <>&nbsp;&nbsp;</>
                        )}
                      </div>
                      {/* {
                        suggestions.benefits!=null ?
                        <>
                        </>
                        :
                        <></>

                      } */}

                      {/* { */}

                      {/* !Stringutility.isNullOrEmpty(suggestions.benefits)?( */}

                      <>
                        <div className="jobsuggestion_status col-span-4">
                        {suggestions.showPay == false ? (
                            <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>
                          ) : (
                            <>{checkJobSalary(suggestions)}</>
                          )}
                          {/* <div className=""> {checkJobSalary(suggestions)}</div> */}
                          <div className="JobPreferences t-benefits-container">
                            {suggestions.benefits != null ? (
                              <span
                                className="  rounded-[4px] font-semibold text-xs text-primary-white min-w-max t-hand-cursor-pointer"
                                title={getTotalSelectedBenefits(
                                  suggestions.benefits
                                )}
                              >
                                <>{getJobBenefits(suggestions.benefits)}</>
                              </span>
                            ):(<>&nbsp;&nbsp;
                            </>)}
                          </div>
                        </div>
                      </>

                      {/* ):(<>&nbsp;&nbsp;</>)} */}
                    </div>
                  {/* </div> */}
                </div>
              );
            })
          ) : (
            <></>
          )}
        </div>
        </div></>
  );
};

export default JobSuggestions;